import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-modal-header-buttons',
  template: '<ng-content />',
  host: {
    '[class.td-wb-modal__header-buttons]': 'true'
  }
})
export class ModalHeaderButtonsComponent {
}
